import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { MoreHorizontal, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Pixel } from '@/types/pixel';

interface PixelActionMenuProps {
  pixel: Pixel;
  onRemove: (pixel: Pixel) => void;
}

export function PixelActionMenu({ pixel, onRemove }: PixelActionMenuProps) {
  useLanguage();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0 hover:bg-[#F1F5F9] focus:ring-2 focus:ring-[#437DFF] focus:ring-offset-2"
          aria-label={translateInterfaceText("Abrir menu de ações")}
        >
          <MoreHorizontal className="w-4 h-4 text-[#64748B]" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-48 animate-in zoom-in-95 duration-100"
      >
        <DropdownMenuItem
          onClick={() => onRemove(pixel)}
          className="cursor-pointer text-red-600 transition-all duration-150 ease-in-out data-[highlighted]:bg-red-600 data-[highlighted]:text-white"
        >
          <Trash2 className="w-4 h-4 mr-2" />
          {translateInterfaceText("Remover pixel")}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
